'use client';

import { createContext, useContext, useMemo } from 'react';

const ProductContext = createContext();

export const useProductContext = () => useContext(ProductContext);

// NOTE: This context intentionally carries ONLY the product summary list.
// It is threaded through the root layout, so its payload is serialized into
// the RSC response for every route on the site (home, about, contact, etc).
// The heavy lookup tables (VARIANTS_REGISTRY, ACCESSORIES_REGISTRY,
// VARIANT_GROUPS, ACCESSORY_GROUPS, VERSA_PANEL_TABLE, OCTOBOX_TABLE) are
// NOT included here on purpose — they're only needed by a couple of
// route/feature-specific components, which now source them directly
// (server props on the product detail page, or a lazy client-side import
// for the inquiry slide-over) instead of paying the cost on every page.
// See: src/app/products/[product]/page.js and src/components/layout/OverlayRoot.js
const ProductProvider = ({ children, productData }) => {
    const products = productData?.products ?? [];

    const contextValue = useMemo(
        () => ({
            products,
        }),
        [products],
    );

    return (
        <ProductContext.Provider value={contextValue}>
            {children}
        </ProductContext.Provider>
    );
};

export default ProductProvider;
